<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>会员管理</el-breadcrumb-item>
			<el-breadcrumb-item>会员列表</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="昵称">
				<el-input v-model="item.nick_name" placeholder="请输入昵称" size="small"></el-input>
			</el-form-item>
			<el-form-item label="手机号">
				<el-input v-model="item.mobile" placeholder="请输入手机号" size="small"></el-input>
			</el-form-item>
			<el-form-item label="会员级别">
				<el-select v-model="item.level" clearable placeholder="请选择" size="small">
					<el-option v-for="item in levelOptions" :key="item.value" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="add" size="medium" v-auth="['store/member/add']">添加会员</el-button>
				<el-button type="danger" size="small" @click="levelAll">修改会员级别</el-button>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
				<el-button type="success" @click="excelOut" size="medium" v-auth="['store/member/export']">导出</el-button>
			</el-form-item>
		</el-form>

		<!--		数据是list 通过list展示-->
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>


			<el-table-column label="头像" width="60">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.avatar" height="30" style="display:
                        flex;border-radius: 50%" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="nick_name" label="昵称"></el-table-column>
			<el-table-column prop="mobile" label="手机号码" width="120"></el-table-column>
			<el-table-column label="性别" width="60">
				<template slot-scope="scope">
					<div v-if="scope.row.sexy == 1">
						男
					</div>
					<div v-else>
						女
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="levelName" label="会员等级">
				<template slot-scope="scope">
					<div v-if="scope.row.rank">
						{{scope.row.rank.name}}
					</div>
				</template>
			</el-table-column>
<!--			<el-table-column prop="balance" label="账户余额" width="100"></el-table-column>-->
			<el-table-column prop="jifen" label="积分余额" width="90"></el-table-column>
<!--			<el-table-column prop="card" label="卡卷数量"></el-table-column>-->
			<el-table-column label="状态" align="center">
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_enabled == 1">
						启用
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						冻结
					</el-tag>
				</template>
			</el-table-column>
<!--			<el-table-column prop="storeName" label="所属公司"></el-table-column>-->
			<el-table-column prop="created_date" label="创建时间"></el-table-column>
			<el-table-column prop="last_login_date" label="最后登录时间"></el-table-column>
			<el-table-column label="操作" width="300">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['store/member/edit']">编辑</el-button>
					<el-button v-if="store && store.jifen_recharge == 1" size="mini" type="primary" @click="integral(scope.row.id)" v-auth="['store/member/recharge']">积分充值</el-button>
					<el-popconfirm v-if="scope.row.is_enabled == 0" title="您确定要解结这条数据吗？"
						@confirm="freeze(scope.row.id, 1)" class="l10" v-auth="['store/member/freeze']">
						<el-button size="mini" type="danger" slot="reference">解冻</el-button>
					</el-popconfirm>
					<el-popconfirm v-else title="您确定要冻结这条数据吗？" @confirm="freeze(scope.row.id, 0)"
						class="l10" v-auth="['store/member/freeze']">
						<el-button size="mini" type="danger" slot="reference">冻结</el-button>
					</el-popconfirm>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id, 0)"
								   class="l10" v-auth="['store/member/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		<el-dialog title="批量修改会员等级" :visible.sync="gradeVisible" width="30%" :before-close="handleGradeClose">
			<el-form label-position="right" ref="ruleForm" :model="form" label-width="auto">
				<el-form-item label="会员级别">
					<el-select v-model="form.level" clearable placeholder="请选择" size="small">
						<el-option v-for="item in levelOptions" :key="item.value" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmUpdateLevel">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="添加会员" :visible.sync="addVisible" width="30%" :before-close="handleAddClose">
			<el-form label-position="right" ref="FromData" :model="FromData" label-width="auto">
				<el-form-item label="会员手机号" prop="mobile" :rules="[
                        { required: true, message: '手机号码不能为空', trigger: 'blur' }]">
					<el-input v-model="FromData.mobile"></el-input>
				</el-form-item>
				<el-form-item label="真实姓名">
					<el-input v-model="FromData.real_name"></el-input>
				</el-form-item>
				<el-form-item label="昵称">
					<el-input v-model="FromData.nick_name"></el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input type="password" v-model="FromData.password" placeholder="默认123456"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="onSubmit('FromData')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageSize: 20,
				pageNum: 0,
				total: 0,
				page: 1,
				// 查询
				item: {
					referee_id: this.$route.query.referee_id ? this.$route.query.referee_id : 0
				},
				levelOptions: [],
				storeOptions: [],
				store: {

				},
				multipleSelection: [],
				gradeVisible: false,
				form: {

				},
				addVisible: false,
				FromData: {}
			}
		},
		created() {
			this.loadStore()
			this.item.page = this.page
			this.item.limit = this.pageSize
			this.loadList()
		},
		methods: {
			loadStore: function () {
				this.axios.post('/store/index/store', this.item)
				.then(res => {
					this.store = res.data.store
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ''
				// 会员等级列表
				res = await this.axios.post('/store/member.level/list', {
				})
				// 获取数据
				this.levelOptions = res.data.list
				res = await this.axios.post('/store/member/list', this.item)
				.then(res => {
					// 获取数据
					this.list = res.data.list.data
					// 页数 page
					this.total = res.data.list.total
				})
				this.isLoad = !this.isLoad
			},
			add: function () {
				this.addVisible = true
				this.FromData = {}
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Member/MemberListEdit.html',
					query: {
						id: id
					}
				});
			},
			levelAll: function () {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.id)
				}
				if (id.length == 0) {
					this.$message.error({
						message: '请选择会员',
						showClose: false
					});
					return false;
				}
				this.gradeVisible = true
			},
			handleGradeClose: function () {
				this.gradeVisible = false
			},
			handleAddClose: function () {
				this.addVisible = false
			},
			confirmUpdateLevel: function () {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.id)
				}
				if (id.length == 0) {
					this.$message.error({
						message: '请选择商品',
						showClose: false
					});
					return false;
				}

				this.axios.post('/store/member/editLevel', {
					id: id,
					level: this.form.level,
				})
				.then(() => {
					this.$message.success({
						message: '操作成功'
					});
					this.loadList()
					this.gradeVisible = false
				})
				.catch(() => {
				})
			},
			integral(id) {
				this.$router.push({
					path: '/Member/integralEdit.html',
					query: {
						id: id
					}
				});
			},
			//
			freeze(id, type) {
				if (this.isLoad) {
					return
				}

				this.isLoad = !this.isLoad
				this.axios.put('/store/member/freeze', {
						id: id,
						type: type
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '冻结成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			del(id, type) {
				if (this.isLoad) {
					return
				}

				this.isLoad = true
				this.axios.put('/store/member/delete', {
					id: id,
				})
				.then(() => {
					this.isLoad = false
					this.$message.success({
						message: '删除成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = false
				})
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},

			// 分页
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			onSubmit: function (name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.isLoad = true
						this.axios.put('/store/member/add', {
							form: JSON.parse(JSON.stringify(this.FromData))
						})
						.then(() => {
							this.addVisible = false
							this.isLoad = false
							this.$message.success({
								message: '冻结成功',
								showClose: false
							});
							this.loadList()
						})
						.catch(() => {
							this.isLoad = false
						})
					}
				})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);
				this.axios.post('/store/member/export', this.item)
				.then(res => {
					this.isLoad = false
					if (res.code == 1) {
						import('@/vendor/Export2Excel.js').then(excel => {
							var expCellName = res.data.expCellName
							var tHeader = []
							var filterVal = []
							for (var i in expCellName) {
								tHeader.push(expCellName[i])
								filterVal.push(i)
							}
							const expTableData = res.data.expTableData
							const data = this.formatJson(filterVal, expTableData)
							var d = new Date()
							var year = d.getFullYear()
							var month = d.getMonth()
							var date = d.getDate()
							var hour = d.getHours()
							var minute = d.getMinutes()
							var second = d.getSeconds()
							month = month < 10 ? '0' + month : month
							date = date < 10 ? '0' + date : date
							hour = hour < 10 ? '0' + hour : hour
							minute = minute < 10 ? '0' + minute : minute
							second = second < 10 ? '0' + second : second
							excel.export_json_to_excel({
								header: tHeader,
								data,
								filename: '会员导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
								autoWidth: this.autoWidth,
								bookType: this.bookType
							})
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
							duration: 3 * 1000
						})
					}
				})
			}
		}
	}
</script>
<style scoped>
	.el-form--inline .el-form-item {
		margin-bottom: 16px;
	}

	.search {
		margin-top: 16px;
	}
</style>
